module.exports = __webpack_public_path__ + "static/media/continuous-improvement.1e9c424c.svg";